import { useCallback, useEffect, useState } from 'react';
import axios from '../utils/axios';

export type PosHealth = {
  configured: boolean;
  type: string | null;
  status: string; // CONNECTED | ERROR | SYNCING | NOT_CONFIGURED
};

export type SystemHealth = {
  pos: PosHealth;
  voice: string; // UP | DOWN
  aws: string; // UP | DOWN
  reachable: boolean; // false si l'appel échoue (serveur AWS injoignable)
};

const DEFAULT: SystemHealth = {
  pos: { configured: false, type: null, status: 'NOT_CONFIGURED' },
  voice: 'DOWN',
  aws: 'DOWN',
  reachable: false,
};

/**
 * Interroge périodiquement l'état du système (/api/v1/health).
 * Si l'appel échoue, le serveur AWS est considéré injoignable (tout DOWN).
 */
export function useSystemHealth(pollSeconds = 60): SystemHealth {
  const [health, setHealth] = useState<SystemHealth>(DEFAULT);

  const fetchHealth = useCallback(async () => {
    try {
      const res = await axios.get('/api/v1/health', { timeout: 5000 });
      setHealth({
        pos: res.data?.pos ?? DEFAULT.pos,
        voice: res.data?.voice ?? 'DOWN',
        aws: res.data?.aws ?? 'UP',
        reachable: true,
      });
    } catch (e) {
      setHealth({ ...DEFAULT, reachable: false });
    }
  }, []);

  useEffect(() => {
    fetchHealth();
    if (!pollSeconds || pollSeconds <= 0) return undefined;
    const id = window.setInterval(fetchHealth, pollSeconds * 1000);
    return () => window.clearInterval(id);
  }, [fetchHealth, pollSeconds]);

  return health;
}